import { AssetIdentifiers, AssetType } from '../types/asset-permissions.types'

export function getAssetIdFromIdentifiers(assetIdentifiers: AssetIdentifiers): string | null {
  const { isBatch, batchId, directoryId } = assetIdentifiers
  const assetId = (isBatch ? batchId : directoryId) as string
  const assetType = isBatch ? AssetType.BATCH : AssetType.DIRECTORY
  return !assetId ? null : `${assetType}:${assetId}`
}

export function getAssetIdentifiersFromAssetId(
  assetId: string,
  isWhitelabel?: boolean,
  isCodeSubdomain?: boolean
): AssetIdentifiers {
  if (isWhitelabel) {
    return {
      subdomainId: assetId,
      isBatch: isCodeSubdomain ?? false
    }
  }
  if (!assetId?.includes(':')) {
    return {
      pageId: assetId,
      isBatch: false
    }
  }

  const assetIdParts = assetId?.split(':')

  const type = assetIdParts?.[0]
  const id = assetIdParts?.[1]

  if (!type || !id) return { isBatch: false }

  if (type === 'directory') {
    return {
      directoryId: id,
      isBatch: false
    }
  }

  if (type === AssetType.PAGE_TEMPLATE) {
    return {
      pageTemplateId: id,
      isBatch: false
    }
  }

  return {
    batchId: id,
    isBatch: true
  }
}
